var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"dovetail-app"},[_c('snackbar'),_vm._v(" "),_c('v-slide-y-transition',{attrs:{"mode":"out-in"}},[_c('router-view',{key:_vm.key})],1),_vm._v(" "),_c('dialogbox')],1)}
var staticRenderFns = []

export { render, staticRenderFns }